import { Effect, Layer, type Context } from "effect";
import { editorModelDependencyFailure } from "./model.ts";
import { EditorModelIo } from "./model-service.ts";
import { EditorPlatform } from "./platform-service.ts";
type Port = Context.Service.Shape<typeof EditorModelIo>;
export const EditorModelIoLazyLive = Layer.effect(EditorModelIo, Effect.gen(function* () {
  const platform = yield* EditorPlatform;
  const load = Effect.tryPromise({ try: () => import("./model-live.ts"), catch: editorModelDependencyFailure });
  return EditorModelIo.of({
    allocateRoot: Effect.try({ try: () => globalThis.crypto.randomUUID(), catch: editorModelDependencyFailure }),
    acquire: Effect.fn("Frontend.EditorModelIo.lazyAcquire")(function* (...args: Parameters<Port["acquire"]>) { yield* platform.ready.pipe(Effect.mapError(editorModelDependencyFailure)); return yield* (yield* load).editorModelIo.acquire(...args); }),
    read: Effect.fn("Frontend.EditorModelIo.lazyRead")(function* (...args: Parameters<Port["read"]>) { return yield* (yield* load).editorModelIo.read(...args); }),
    write: Effect.fn("Frontend.EditorModelIo.lazyWrite")(function* (...args: Parameters<Port["write"]>) { return yield* (yield* load).editorModelIo.write(...args); })
  });
}));
